module.exports = __webpack_public_path__ + "static/img/person.75d05a04.png";